import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Stack,
} from "react-bootstrap";
import React, { useState, useEffect, useContext } from "react";
import AccountPropertyBox from "../../components/AccountPropertyBox";
import { UserContext } from "../../providers/UserProvider";
import { uploadUserData } from "../../functions/accountFunctions";
import Loading from "../../components/Loading";
import {
  getMissingVideos,
  migrateVideoLinksFromYoutubeToVimeo,
  updateAllStructuredLessonIcons,
  uploadAllExercisesToFirestore,
} from "../../functions/databaseBatchFunctions";
import { getVideoThumbnail } from "../../helper-functions/UtilFunctions";
import {
  deleteEmptySchools,
  downloadAnalyticalDataAsCSV,
  getAnalyticalData,
} from "../../functions/analyticsFunctions";
import { uploadIconsAndColoursToLessons } from "../../firebase";
import { getExactPortalLink } from "../../functions/subscriptionFunctions";
import { incrementOrderInFirestore } from "../../functions/structuredLessonsFunctions";
import { uploadExercises } from "../../functions/workoutFunctions";
import { cleanSchoolAccessCodes, createAccessIDs } from "../../functions/schoolFunctions";

function MyAccountPage() {
  const [saving, setSaving] = useState(false);
  const [yearGroup, setYearGroup] = useState(0);
  const [email, setEmail] = useState("");

  const [editAccount, setEditAccount] = useState(false);

  const { data2 } = useContext(UserContext);

  const [firstName, setFirstName] = useState("");

  const [secondName, setSecondName] = useState("");

  const [phoneNumber, setPhoneNumber] = useState("");

  const [userRole, setUserRole] = useState("");

  const [classroomName, setClassroomName] = useState("");
  useEffect(() => {
    document.title = "Daly Exercise+ | Account";

    if ("Guid" in data2) {
      setFirstName(data2.FirstName ? data2.FirstName : "");
      setSecondName(data2.Surname ? data2.Surname : "");
      setPhoneNumber(data2.ContactNumber ? data2.ContactNumber : "");
      setUserRole(data2.Role ? data2.Role : "");
      setClassroomName(data2.ClassroomName ? data2.classroomName : "");
      setEmail(data2.Email);
      let year = data2.Year ? data2.Year : 0;
      setYearGroup(year);
      // cleanSchoolAccessCodes("bd360c05-87bf-46e5-846a-480bcd22ee1a");
    }
  }, [data2]);

  const onEditAccountClicked = async () => {
    if (editAccount) {
      setSaving(true);

      let account = {
        FirstName: firstName,
        Surname: secondName,
        ContactNumber: phoneNumber,
        Role: userRole,
        ClassroomName: classroomName,
        Year: yearGroup,
      };
      await uploadUserData(data2.Guid, account);

      setSaving(false);
    }

    setEditAccount(!editAccount);
  };

  return (
    <Container fluid>
      <div className="dashboard-body">
        <Container>
          <h1 className="pageTitle title-margin">My Account</h1>
          <br />
          <Form>
            <div className="white-box">
              <Stack direction="horizontal">
                <h3 className="title-margin page-title">Email</h3>
                <h4 className="ms-auto">{email}</h4>
              </Stack>
            </div>

            <Row>
              <Col md={8}>
                <div className="white-box equal-height">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="firstName">
                        <Form.Label className="form-label-text">
                          First Name
                        </Form.Label>
                        <Form.Control
                          disabled={!editAccount}
                          required
                          placeholder="First Name"
                          aria-describedby="firstNameHelpBlock"
                          onChange={(event) => setFirstName(event.target.value)}
                          value={firstName}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="secondName">
                        <Form.Label className="form-label-text">
                          Second Name
                        </Form.Label>
                        <Form.Control
                          disabled={!editAccount}
                          value={secondName}
                          required
                          placeholder="Second Name"
                          aria-describedby="secondNameHelpBlock"
                          onChange={(event) =>
                            setSecondName(event.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="contactNumber">
                        <Form.Label className="form-label-text">
                          Contact Number
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text>+353</InputGroup.Text>
                          <Form.Control
                            disabled={!editAccount}
                            type="tel"
                            value={phoneNumber}
                            required
                            placeholder=""
                            aria-describedby="phoneNumberHelpBlock"
                            onChange={(event) =>
                              setPhoneNumber(event.target.value)
                            }
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="userRole">
                        <Form.Label className="form-label-text">
                          Role
                        </Form.Label>
                        <Form.Control
                          disabled={!editAccount}
                          required
                          value={userRole}
                          placeholder="Principal, Teacher etc"
                          aria-describedby="userRoleHelpBlock"
                          onChange={(event) => setUserRole(event.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="userRole">
                        <Form.Label className="form-label-text">
                          Classroom Name
                        </Form.Label>
                        <Form.Control
                          disabled={!editAccount}
                          value={classroomName}
                          placeholder="My Classroom"
                          aria-describedby="userRoleHelpBlock"
                          onChange={(event) =>
                            setClassroomName(event.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="userRole">
                        <Form.Label className="form-label-text">
                          Content Year Group
                        </Form.Label>
                        <Form.Select
                          disabled={!editAccount}
                          value={yearGroup}
                          onChange={(event) => setYearGroup(event.target.value)}
                        >
                          <option value={0}>Junior or Senior</option>
                          <option value={1}>1st or 2nd Class</option>
                          <option value={2}>3rd or 4th Class</option>
                          <option value={3}>5th or 6th Class</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col md={4}>
                <div className="white-box equal-height">
                  <h3 className="title-margin page-title text-center">
                    Actions
                  </h3>
                  {saving ? (
                    <div className="custom-loader" />
                  ) : (
                    <button
                      onClick={onEditAccountClicked}
                      className="custom-button-big w-100 mt-3"
                      type="button"
                    >
                      {editAccount ? "Save" : "Edit"}
                    </button>
                  )}
                  {/* <button
                      className="custom-button-big custom-button-variant-good w-100 mt-3 mb-3"
                    >
                      Help
                    </button>
                    <button
                      className="custom-button-big custom-button-variant-bad w-100 mt-3"
                    >
                      Delete Account
                    </button> */}
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    </Container>
  );
}

export default MyAccountPage;

const exercises = [
  {
    Category: "Aerobic Exercises",
    Name: "Running on the spot",
    Guid: "cd98b202-351e-480a-9b06-05a153a23b68",
    GifUri: "new/Running On The Spot.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Marching",
    Guid: "677814d3-8667-4ca5-8965-2c7e5b802af7",
    GifUri: "new/Marching.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Pull the Rope",
    Guid: "e0a9fb06-5213-41a4-839a-94bcded62fd3",
    GifUri: "new/Pull the Rope.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "High Knee Punches",
    Guid: "aa759b57-379f-4d50-9ba6-310871c81c6a",
    GifUri: "new/High Knee Punches.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Heel Kicks",
    Guid: "0e9fb2e6-7881-4633-9d0d-99c3b59cf80c",
    GifUri: "new/Heel Kick.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Jumping Jacks",
    Guid: "5bdcdc92-4ae1-4dbd-9090-f25e4c3ab513",
    GifUri: "new/Jumping Jacks.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Front Jacks",
    Guid: "e13bd528-c1c0-4385-8193-0201c8e25e6a",
    GifUri: "new/Front Jacks.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Foot Fire",
    Guid: "6faf1396-8452-4ff2-8cf3-fc6223429904",
    GifUri: "new/Foot Fire.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Mummy Kicks",
    Guid: "d3d84b9a-38e8-4ef7-827d-e9adb0ddc422",
    GifUri: "new/Mummy Kicks.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Mountain Climbers",
    Guid: "affd8afd-f446-42d5-8605-e113b1e208d8",
    GifUri: "new/Mountain Climbers.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "High Knee Shuffle",
    Guid: "341e65e5-1781-4d5b-a03b-78ac15e669f0",
    GifUri: "new/High Knee Shuffle.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Skip Touch Toe",
    Guid: "f28b8a68-2118-4921-8b2c-c845c03705d7",
    GifUri: "new/Skip Touch Toe.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Skip Punch",
    Guid: "b6817292-190b-4a09-a92b-2588fa4d2b09",
    GifUri: "new/Skip Punch.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Shuffle Jacks",
    Guid: "c5552a84-1b3d-4423-9722-8e600a2fa8ea",
    GifUri: "new/Shuffle Jacks.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Skip Squat",
    Guid: "33f160e4-c28e-4576-934b-68dcdcf29a56",
    GifUri: "new/Skip Squat.mp4",
  },
  {
    Category: "Aerobic Exercises",
    Name: "Quick Feet",
    Guid: "0863468d-b3ad-4224-a557-bf31b077dfa4",
    GifUri: "new/Seated Quick Feet.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Squats",
    Guid: "0690e2d2-c39f-44a7-bf98-a36d4230db59",
    GifUri: "new/Squats.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Squat Jumps",
    Guid: "3b156324-c1b6-4c03-bd10-8fe1467a6900",
    GifUri: "new/Squat Jumps.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Jump Shots",
    Guid: "4871b777-ae3b-43e7-a97d-f0dcb1325a54",
    GifUri: "new/Jump Shots.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Lunge",
    Guid: "1505e574-f22b-4d5c-8e17-d0c6d1bfc6c2",
    GifUri: "new/Lunge.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Lunge Toe Touch",
    Guid: "34df9327-8c47-4b24-abee-93ffb192b3f4",
    GifUri: "new/Lunch Toe Touch.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Lunge Punches",
    Guid: "38520840-5d57-4c57-a32f-259025516d9b",
    GifUri: "new/Lunges Punches.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Squat Punches",
    Guid: "4ddea537-fb74-46f7-919b-1c31e4f9e989",
    GifUri: "new/Squat Punches.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Jump, Jump, Squat",
    Guid: "7e8b14f7-d1d5-4fb9-a48f-93997bf65d81",
    GifUri: "new/Jump Jump Squat.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Squat Knee to Elbow",
    Guid: "1b35ea82-f267-4f39-b6b2-db8edf9655dc",
    GifUri: "new/Squat Knee To Elbow.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Squat Kicks",
    Guid: "c819a59b-22e7-4252-9a5c-857226b288ab",
    GifUri: "new/Squat Kicks.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Single Leg Lunge",
    Guid: "a71ab779-d672-427e-82b1-3cff1884d07f",
    GifUri: "new/Single Leg Lunge.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Split Lunge",
    Guid: "c60c4e06-312a-4460-9655-e65f3e3b1714",
    GifUri: "new/Split Lunge.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Split Squat",
    Guid: "621f1b70-21ba-470c-b5a7-1455bb39813a",
    GifUri: "new/Split Squat.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Squat Calf Raises",
    Guid: "59e08c16-3af4-4b6f-abab-e0635e85a643",
    GifUri: "new/Squat Calf Raises.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Leg Lift",
    Guid: "7a7b0757-7c3c-4a04-a2c2-4d71fe4ae01d",
    GifUri: "new/Leg Raises.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Leg Back Raises",
    Guid: "577defbd-5778-4490-9527-2ffa8ff76a25",
    GifUri: "new/Leg Back Raises.mp4",
  },
  {
    Category: "Lower Body Exercises",
    Name: "Seated Squat Jumps",
    Guid: "d399612f-67c7-42a4-889c-9a7a725ec41c",
    GifUri: "new/Seated Squat Jumps.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Chair Plank",
    Guid: "6b2d273d-0255-41f5-a4b6-e27cb292534b",
    GifUri: "new/Chair Plank.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Chair Squat",
    Guid: "93ecca5b-0c5b-40b9-af8b-daf267f43a5c",
    GifUri: "new/Chair Squat.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Back Extensions",
    Guid: "8cc25f30-15d9-463e-8467-f36f259c1b63",
    GifUri: "new/Seated Back Extensions.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Hip Thrust",
    Guid: "9ab93a08-3e98-45c1-b7c2-d2342ae129f3",
    GifUri: "new/Seated Hip Thrust.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Jumping Jacks",
    Guid: "629bdc08-0fc0-4495-908a-1da1c903859e",
    GifUri: "new/Seated Jumping Jacks.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Knee Raises",
    Guid: "9eb17e57-1491-4eed-8bd0-3e153a2b40ce",
    GifUri: "new/Seated Knee Raises.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Leg Raise",
    Guid: "2013542a-8556-4ccc-87f4-d9e18711184b",
    GifUri: "new/Seated Leg Raise.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Punches",
    Guid: "247f412f-f9e1-45f2-b869-d21a9e0c2b72",
    GifUri: "new/Seated Punches.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Squat Jumps",
    Guid: "b6df0ef4-ee8b-44c7-b15e-b57e5a65d5d4",
    GifUri: "new/Seated Squat Jumps.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Toe Touches",
    Guid: "46e10089-3d4e-48c5-afcb-6738f1e7e18c",
    GifUri: "new/Seated Toe Touches.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Marching",
    Guid: "d1321f62-6e0f-470b-bfc5-c70cd8af9c41",
    GifUri: "new/Marching.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Sit to Stand",
    Guid: "2349eea7-f873-47de-b243-a97ddbf03a18",
    GifUri: "new/Sit to Stand.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Seated Squat Jumps",
    Guid: "c9c8052a-0f5b-4960-a236-915b987152d7",
    GifUri: "new/Seated Squat Jumps.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Arm Circles",
    Guid: "86ec0085-411c-4e3a-b6cf-6171deea6d98",
    GifUri: "new/Arm Circles.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Bicep Curl Press",
    Guid: "99274fd9-1e14-415e-a89c-eacf2f03f2b9",
    GifUri: "new/Bicep Curl Press.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Bent Over Arm Lift",
    Guid: "181baefc-c067-4681-9b60-18e925840a8b",
    GifUri: "new/Bent Over Arm Lift.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Standing Arm Rotations",
    Guid: "94358807-d2dd-4afc-a352-2b49a4aeb58a",
    GifUri: "new/Standing Arm Rotations.mp4",
  },
  {
    Category: "Adapted Physical Exercises",
    Name: "Kneel to Stand",
    Guid: "3efe7ff8-f5fe-46ec-83c7-5bbfbda6bb3d",
    GifUri: "new/Kneel to Stand.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Plank",
    Guid: "55fcac8d-204e-4757-a13c-2819f890744d",
    GifUri: "new/Plank.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Shoulder Taps",
    Guid: "f2443122-50f2-437d-a2b0-cd4e2116f62d",
    GifUri: "new/Shoulder Taps.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Knee Taps",
    Guid: "e8efaf6a-8c09-42e4-af6e-b20d709807d3",
    GifUri: "new/Knee Taps.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Toe Taps",
    Guid: "267c277e-3408-4a0f-b55b-ebcdf4cba913",
    GifUri: "new/Toe Taps.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Down, Down, Up, Up",
    Guid: "2b08a6c2-4ad5-4d74-9e72-a6efb3f8493c",
    GifUri: "new/Down Down Up Up.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Plank Hip Dips",
    Guid: "b6adc843-7cf5-47df-997e-5cb9335377d9",
    GifUri: "new/Plank Hip Dips.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Butterfly Kicks",
    Guid: "4691744c-85d8-4fc1-9b33-5d94701e3262",
    GifUri: "new/Butterly Kicks.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Criss Cross",
    Guid: "ce36e154-a936-4b33-9768-81adae59792f",
    GifUri: "new/Criss Cross.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Heel Taps",
    Guid: "a8095b04-078e-4e50-ae0d-5de1b65b27b0",
    GifUri: "new/Heel Taps.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Diagonal Mountain Climbers",
    Guid: "45b944fe-b667-4b79-9c34-ed990575809e",
    GifUri: "new/Diagonal Mountain Climbers.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Crunches",
    Guid: "d9c91bb6-82a9-4d2d-a230-9c206cc3db8d",
    GifUri: "new/Crunches.mp4",
  },

  {
    Category: "Core Exercises",
    Name: "Dead Bugs",
    Guid: "de0dad3d-b32b-447d-a858-cd3850ba547b",
    GifUri: "new/Dead Bug.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Leg Raises",
    Guid: "5d23af69-673c-4553-b835-484a197e3414",
    GifUri: "new/Leg Raises.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Crab Toe Touch",
    Guid: "042327e1-ee9e-4a0e-b097-5e9f301e08e3",
    GifUri: "new/Crab Toe Touch.mp4",
  },

  {
    Category: "Core Exercises",
    Name: "Reverse Crunch",
    Guid: "58c18855-9bf1-48c2-979c-3a1dad4b63d7",
    GifUri: "new/Seated Crunch.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Sit Ups",
    Guid: "df5a0dd6-9d4d-47e7-8f74-4c1327750311",
    GifUri: "new/Sit Ups.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Plank Variation",
    Guid: "e12542a4-2419-4ac5-bc19-bdc91fec238e",
    GifUri: "new/Plank Variation.mp4",
  },
  {
    Category: "Core Exercises",
    Name: "Spine Rotation",
    Guid: "25867976-1a7f-4e18-b412-968aabaed99e",
    GifUri: "new/Spine Rotation.mp4",
  },
  {
    Category: "Upper Body Exercises",
    Name: "Push Up (On Knees)",
    Guid: "b518b07c-69a5-429e-8157-38b9a687338d",
    GifUri: "new/Push up - On Knees.mp4",
  },
  {
    Category: "Upper Body Exercises",
    Name: "Push Up",
    Guid: "3a2b5907-a528-4347-b0ce-b2af8d1f7e55",
    GifUri: "new/Push Up.mp4",
  },
  {
    Category: "Upper Body Exercises",
    Name: "Shoulders, Knees & Toes",
    Guid: "6be00a5f-cd44-4ac0-b21d-8910b10a271a",
    GifUri: "new/Shoulders, Knees & Toes.mp4",
  },

  {
    Category: "Upper Body Exercises",
    Name: "Dorsel Raise",
    Guid: "5ac050b0-0b78-4805-97f6-52bd50ca7092",
    GifUri: "new/Dorsel Raise.mp4",
  },
  {
    Category: "Upper Body Exercises",
    Name: "Knee Shoulder Tap",
    Guid: "e061881a-12d3-4edd-b29e-6a12b4592c60",
    GifUri: "new/Knee Shoulder Tap.mp4",
  },
];
